import stripeConfig from './config/stripe-config';
import stripeCvc from './filters/stripe-cvc';
import stripeData from './services/stripe-data';
import stripeCheckout from './services/stripe-checkout';
import stripeLoadSdk from './services/stripe-load-sdk';
import stripeCreateToken from './services/stripe-create-token';
import stripeExpirationMonths from './services/stripe-expiration-months';
import stripeExpirationYears from './services/stripe-expiration-years';
import stripeField from './directives/stripe-field';
import stripeForm from './directives/stripe-form';
import stripeValidateCardNumber from './validators/stripe-validate-card-number';
import stripeValidateCardBrand from './validators/stripe-validate-card-brand';
import stripeValidateExpiryDate from './validators/stripe-validate-expiry-date';

export default angular.module('stripe', [])
    .provider('stripeConfig', stripeConfig)
    .filter('stripeCvc', stripeCvc)
    .factory('stripeData', stripeData)
    .factory('stripeCheckout', stripeCheckout)
    .factory('stripeLoadSdk', stripeLoadSdk)
    .factory('stripeCreateToken', stripeCreateToken)
    .factory('stripeExpirationMonths', stripeExpirationMonths)
    .factory('stripeExpirationYears', stripeExpirationYears)
    .directive('stripeField', stripeField)
    .directive('stripeForm', stripeForm)
    .directive('stripeValidateCardNumber', stripeValidateCardNumber)
    .directive('stripeValidateCardBrand', stripeValidateCardBrand)
    .directive('stripeValidateExpiryDate', stripeValidateExpiryDate)
    .name;



// WEBPACK FOOTER //
// ./stripe/stripe-module.js